(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('PrEmrIntegrationLogSearch', PrEmrIntegrationLogSearch);

    PrEmrIntegrationLogSearch.$inject = ['$resource'];

    function PrEmrIntegrationLogSearch($resource) {
        var resourceUrl =  'api/_search/patient-result-emr-integration-logs';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
